import { connect } from 'react-redux';
import PresentationComponent from '../../../components/event/EventQueryExposureModal';
import { exposeFunnelQuery } from '../../../actions/funnel';
import {
  getFunnelExposureError,
  getFunnelSQL,
  getUpdatingFunnel,
} from '../../../reducers/analyticsApp';

const mapStateToProps = (state) => ({
  sql: getFunnelSQL(state),
  error: getFunnelExposureError(state),
  updatingItems: getUpdatingFunnel(state),
  showButton: true,
});

const mapDispatchToProps = (dispatch) => ({
  expose: () => dispatch(exposeFunnelQuery()),
});

const EventsQueryExposureModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(PresentationComponent);

export default EventsQueryExposureModal;
